import { NgModule } from '@angular/core';
import { LibInfoIconComponent } from './lib-info-icon.component';

@NgModule({
  declarations: [LibInfoIconComponent],
  imports: [],
  exports: [LibInfoIconComponent],
})
export class LibInfoIconModule {}
